<template>
  <div class="guide">
    <img
      src="https://appd.knowbox.cn/ss/official/download/img/openBrowse3.png"
      alt="右上角打开默认浏览器"
    />
  </div>
</template>
<script>
export default {
  name: 'GuideIOS',
};
</script>
<style scoped>
.guide {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  text-align: center;
  z-index: 100;
}
.guide img {
  width: 85%;
}
</style>
